module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("\n    Payment rule\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b825de8a"}!./src/app/pages/payment-rules/index/index.html
// module id = 1438
// module chunks = 0